import { Typography, Tag } from 'antd';

export default function Data({
  title = null,
  value = null,
  emptyValue = 'N/A',
  className = '',
  style = {},
  copyable = false,
  list = false,
  isTag = false,
  tagColor = 'default',
  children = null
}) {
  
  const valueToRender = children ?? (list
    ? (value.length ? <ul>{ value.map((text) => <li> {text} </li>)}</ul> : emptyValue) : (value || emptyValue));

  return (<>
    { isTag && <Tag color={tagColor}>{title && <small>{title}:</small>} <strong>{valueToRender}</strong></Tag> }
    {
      !isTag && <div>
        { title && <Typography.Text style={{ display: 'block' }} type="secondary" strong><small>{title}</small></Typography.Text> }
        <Typography.Text style={{ display: 'block' }} copyable={copyable && value}>{ valueToRender }</Typography.Text>
      </div>
    }
  </>)
}